module.exports = __webpack_public_path__ + "media/svg-new/notification-dba4b200.svg";